'use client';

import { c as _c } from "react/compiler-runtime";
import { type Factiii } from '@shared/all/domains/factiiis';
import useLocalPreference from '@shared/utils/hooks/useLocalPreference';
import { X } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';
import TagPills from '../../../common/TagPills';
import Input from '../../../UI/Input';
type Props = {
  selectedFactiiis?: Factiii[];
};
const ActiveFiltersDisplay: React.FC<Props> = t0 => {
  const $ = _c(26);
  const {
    selectedFactiiis
  } = t0;
  const {
    localPreferenceState,
    updatedLocalPreference
  } = useLocalPreference();
  const dataFilterInputRef = useRef(null);
  const hasFocusedRef = useRef(false);
  const [showDataFilterInput, setShowDataFilterInput] = useState(localPreferenceState.dataFilter.length > 0);
  let t1;
  if ($[0] !== localPreferenceState.dataFilter.length) {
    t1 = () => {
      if (localPreferenceState.dataFilter.length > 0) {
        setShowDataFilterInput(true);
      }
    };
    $[0] = localPreferenceState.dataFilter.length;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== localPreferenceState.dataFilter) {
    t2 = [localPreferenceState.dataFilter];
    $[2] = localPreferenceState.dataFilter;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== localPreferenceState.dataFilter.length) {
    t3 = e => {
      if ((e.key === "Backspace" || e.key === "Delete") && localPreferenceState.dataFilter.length === 0) {
        setShowDataFilterInput(false);
      }
      return false as const;
    };
    $[4] = localPreferenceState.dataFilter.length;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleKeyDown = t3;
  let t4;
  if ($[6] !== updatedLocalPreference) {
    t4 = () => {
      updatedLocalPreference({
        dataFilter: ""
      });
      setShowDataFilterInput(false);
    };
    $[6] = updatedLocalPreference;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const handleCloseDataFilter = t4;
  const hasActiveFilters = localPreferenceState.selectedFactiiis.length > 0 || localPreferenceState.dataFilter.length > 0 || showDataFilterInput;
  let t5;
  let t6;
  if ($[8] !== localPreferenceState.dataFilter.length) {
    t5 = () => {
      let timer;
      if (localPreferenceState.dataFilter.length > 0 && dataFilterInputRef.current && !hasFocusedRef.current && document.activeElement !== dataFilterInputRef.current) {
        timer = setTimeout(() => {
          if (dataFilterInputRef.current) {
            dataFilterInputRef.current.focus();
            hasFocusedRef.current = true;
          }
        }, 100);
      }
      return () => {
        if (timer) {
          clearTimeout(timer);
        }
        hasFocusedRef.current = false;
      };
    };
    t6 = [localPreferenceState.dataFilter.length];
    $[8] = localPreferenceState.dataFilter.length;
    $[9] = t5;
    $[10] = t6;
  } else {
    t5 = $[9];
    t6 = $[10];
  }
  useEffect(t5, t6);
  if (!hasActiveFilters) {
    return null;
  }
  let t7;
  if ($[11] !== localPreferenceState.selectedFactiiis || $[12] !== updatedLocalPreference) {
    t7 = factiiiId => {
      const newSelectedFactiiis = localPreferenceState.selectedFactiiis.filter(id => id !== factiiiId);
      updatedLocalPreference({
        selectedFactiiis: newSelectedFactiiis
      });
    };
    $[11] = localPreferenceState.selectedFactiiis;
    $[12] = updatedLocalPreference;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const handleRemoveFactiii = t7;
  let t8;
  if ($[14] !== handleRemoveFactiii || $[15] !== selectedFactiiis) {
    t8 = selectedFactiiis && selectedFactiiis.length > 0 && <div><TagPills tags={selectedFactiiis.map(_temp)} onRemove={tag => handleRemoveFactiii(tag.id)} showContainer={false} /></div>;
    $[14] = handleRemoveFactiii;
    $[15] = selectedFactiiis;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== handleCloseDataFilter || $[18] !== handleKeyDown || $[19] !== localPreferenceState.dataFilter || $[20] !== showDataFilterInput || $[21] !== updatedLocalPreference) {
    t9 = showDataFilterInput && <div className="flex min-w-48 flex-1 items-center"><Input ref={dataFilterInputRef} value={localPreferenceState.dataFilter} onChange={value => {
        updatedLocalPreference({
          dataFilter: value
        });
      }} onKeyDown={handleKeyDown} label="Search in factiii data..." icons={[<button key="clear" onClick={handleCloseDataFilter} className="text-textSecondary transition-all hover:scale-[1.05] hover:text-primary active:scale-[0.95]" title="Clear data filter"><X size={18} /></button>]} /></div>;
    $[17] = handleCloseDataFilter;
    $[18] = handleKeyDown;
    $[19] = localPreferenceState.dataFilter;
    $[20] = showDataFilterInput;
    $[21] = updatedLocalPreference;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t8 || $[24] !== t9) {
    t10 = <div className="anim-enter mt-4 [--enter-y:-10px]"><div className="rounded-lg border border-ds-border-standard bg-gradient-to-r from-background-secondary to-background-light p-4 shadow-md"><div className="flex flex-wrap items-center gap-2">{t8}{t9}</div></div></div>;
    $[23] = t8;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
};
export default ActiveFiltersDisplay;
function _temp(factiii) {
  return {
    id: factiii.id,
    type: "factiii",
    name: factiii.name,
    slug: factiii.slug,
    avatarKey: factiii.avatarKey,
    spaceSlug: factiii.spaceSlug
  };
}